import { render } from "./InfoTab.vue?vue&type=template&id=53600d54&scoped=true"
import script from "./InfoTab.vue?vue&type=script&lang=js"
export * from "./InfoTab.vue?vue&type=script&lang=js"

import "./InfoTab.vue?vue&type=style&index=0&id=53600d54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53600d54"]])

export default __exports__